import React from 'react';
import './aiintegrations.css';
import { motion } from 'framer-motion';
import { FaBrain, FaRobot, FaChartLine, FaCloud } from 'react-icons/fa';

const AIIntegrations = () => {
  const items = [
    {
      title: '🤖 Intelligent Automation',
      icon: <FaRobot />,
      desc: 'Automating business processes with AI-driven decision making.',
    },
    {
      title: '🧠 Machine Learning Models',
      icon: <FaBrain />,
      desc: 'Custom ML models trained to understand and adapt in real time.',
    },
    {
      title: '📈 Predictive Analytics',
      icon: <FaChartLine />,
      desc: 'Forecasting business trends with smart insights.',
    },
    {
      title: '☁️ Cloud AI Services',
      icon: <FaCloud />,
      desc: 'Seamless AI integration with scalable cloud platforms.',
    },
  ];

  return (
    <motion.div
      className="ai-container"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1 className="ai-title">🤖 AI Integrations</h1>
      <p className="ai-subtitle">Smart solutions powered by intelligence and automation</p>

      <div className="ai-grid">
        {items.map((item, index) => (
          <motion.div
            className="ai-card"
            key={index}
            whileHover={{ scale: 1.05, rotate: 1 }}
            transition={{ type: 'spring', stiffness: 200 }}
          >
            <div className="ai-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default AIIntegrations;
